const Config: any = {
  BaseUrl: "https://api.solusinegeri.com/",
  BaseUrlRedirectMember:"https://app.solusinegeri.com",
  BaseUrlRedirectMerchant:"https://merchant.solusinegeri.com",
};

export default Config;
